<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
}
</style>
<template>
  <div id="page-user-list">
    <!--<div class="header-custome">
      <h2>Page View Report</h2>
    </div>-->
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="vx-row w-full">
          <div class="vx-col md:w-1/2 w-full mt-4">
            <label>
              <b>User Journey Of:&nbsp;</b>
            </label>
            <label>{{ UserName }}</label>
          </div>
        </div>
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow mt-4">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ pageViewUserData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : pageViewUserData.length }} of {{ pageViewUserData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <!--<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>-->
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Attendee-->

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
           @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-42"
          >
            <span class="mr-2 leading-none" v-if="filtrDay == 0"><small>Filter : 24 hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay > 0"><small>Filter : {{filtrDay}} days</small></span>
             <span class="mr-2 leading-none" v-else-if="filtrHours > 0"><small>Filter : {{filtrHours}} hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay == -1"><small>Filter : All</small></span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
              <vs-dropdown-item @click="changeFilterByDays(6)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>6 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(12)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>12 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(24)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>24 Hours</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(3)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 3 days</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(7)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 7 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(-1)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>All</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
                 <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="pageViewUserData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

import parser from "ua-parser-js";

// Store Module
import moduleAnalytics from "@/store/analytics/moduleAnalytics.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/PageViewCellRendererActions.vue";
import moment from "moment-timezone";

//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      filterModel: -1,
      filtrDay: null,
      filtrHours: null,
      settingsData: { ShowMeetingButton: false },
      popupActiveMail: false,
      popupActiveMailUpdate: false,
      mailRecepients: [],
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      userName: "",
      pageView_UserData: [],
      columnDefs: [
        //{
        //  //headerName: 'ID',
        //  field: "AttendeeId",
        //  //width: 40,
        //  filter: false,
        //  checkboxSelection: true,
        //  headerCheckboxSelectionFilteredOnly: true,
        //  headerCheckboxSelection: true
        //},
          {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Date & Time",
          field: "ActionTimeStr",
          filter: true,
          width: 250
        },
        {
          headerName: "Page URL",
          field: "page",
          filter: true,
          width: 200
        },
        {
          headerName: "Type",
          field: "Action",
          filter: true,
          width: 100
        },
        {
          headerName: "Action",
          field: "ActionLabel",
          filter: true,
          width: 200
        },
        {
          headerName: "Device Info",
          field: "DeviceInfo",
          filter: true,
          width: 400
        }
        //{
        //  headerName: "User Agent",
        //  field: "UserAgent",
        //  filter: true,
        //  width: 400
        //}
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    };
  },
  computed: {
    UserName() {
      return vm.userName;
    },
    pageViewUserData() {
      return this.pageView_UserData;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 20;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    changeFilterByDays(filterDayOrhours){
      if(filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24){
        this.filtrHours = filterDayOrhours;
        this.filtrDay = null;
      }else if(filterDayOrhours == -1){
        this.filtrDay = -1;
      }else{
          this.filtrDay = filterDayOrhours;
          this.filtrHours = null;
      }
      this.fetch_user_data(this.$route.params.uid,filterDayOrhours);
    },
    fetch_user_data(uid,filterdays) {
      this.$vs.loading();
      //console.log(AttendeeId)
      //if (type == "view") {
      this.$store
        .dispatch("analytics/fetchUserJourneyDetailsData",{uid, filterdays})
        .then(res => {
          //debugger;
          var resultData = res.data;
          this.pageView_UserData = resultData;
          this.$vs.loading.close();
        })
        .catch(err => {
          //debugger;
          /*if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }*/
           this.$vs.loading.close();
          console.error(err);
        });
      //} else {
      //  this.$store
      //    .dispatch("analytics/fetchPageViewUserDetailsData", page, type, uid)
      //    .then(res => {
      //      debugger;
      //      this.pageView_UserData = res.data;
      //    })
      //    .catch(err => {
      //      debugger;
      //      /*if (err.response.status === 404) {
      //      this.user_not_found = true;
      //      return;
      //    }*/
      //      console.error(err);
      //    });
      //}
    },
    getFormattedDate: function(seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var year = dt.getFullYear();
      //const monthNames = [
      //  "January",
      //  "February",
      //  "March",
      //  "April",
      //  "May",
      //  "June",
      //  "July",
      //  "August",
      //  "September",
      //  "October",
      //  "November",
      //  "December"
      //];
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      var formattedValue =
        monthNames[month] + " " + day.toString() + ", " + year;
      return formattedValue;
    },
    getFormattedTime: function(seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var seconds = dt.getSeconds();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
      var formattedValue =
        hours.toString() +
        ":" +
        minutes.toString() +
        ":" +
        seconds.toString() +
        " " +
        amPM;
      return formattedValue;
    },
    getDevice: function(uastring) {
      debugger;
      var retVal = "";
      var result = parser(uastring);

      //console.log(parser);
      console.log(result);
      //parser.setUA(uastring);
      //var result = parser.getResult();
      // this will also produce the same result (without instantiation):
      // var result = UAParser(uastring);
      if (result.device != undefined) {
        if (result.device.vendor != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.device.vendor;
          if (result.device.model != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.device.model;
          }
        }
      }
      if (result.os != undefined) {
        if (result.os.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.os.name;
          if (result.os.version != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.os.version;
          }
        }
      }
      if (result.browser != undefined) {
        if (result.browser.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.browser.name;
          if (result.browser.major != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.browser.major;
          }
        }
      }
      return retVal;
      //console.log(result.browser);        // {name: "Chromium", version: "15.0.874.106"}
      //console.log(result.device);         // {model: undefined, type: undefined, vendor: undefined}
      //console.log(result.os);             // {name: "Ubuntu", version: "11.10"}
      //console.log(result.os.version);     // "11.10"
      //console.log(result.engine.name);    // "WebKit"
      //console.log(result.cpu.architecture);   // "amd64"
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];
        var timeZone = [];

        timeZone.push("Report Exported In ")
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"'+ timezone + ' Time Zone' + '"');
        datarow.push("Page URL");
        datarow.push("Type");
        datarow.push("Action");
        datarow.push("Date & Time");
        datarow.push("Device Info");
        var userJourneyData = [];
        userJourneyData.push(datarow);
        var TimeZoneHeader = [];
		    TimeZoneHeader.push(timeZone);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          
          var pageUrl = row.page == undefined ? "" : row.page;
          datarow.push('"' + pageUrl + '"');
          var type = row.Action == undefined ? "" : row.Action;
          datarow.push('"' + type + '"');
          var action = row.ActionLabel == undefined ? "" : row.ActionLabel;
          datarow.push('"' + action + '"');
          var dateTime = row.ActionTimeStr == undefined ? "" : row.ActionTimeStr;
          datarow.push('"' + dateTime + '"');
          var deviceInfo = row.DeviceInfo == undefined ? "" : row.DeviceInfo;
          datarow.push('"' + deviceInfo + '"');
          userJourneyData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function(rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        userJourneyData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "UserJourneyData"+"_"+this.userName+"_"+this.$route.params.uid+"_"+ dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one user journey data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    updateSearchQuery(val) {
     this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    //vm = this;
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    if (this.$route.params.uid == undefined) {
      this.$router.push({ name: "analytics-user-journey" }).catch(() => {});
    } else {
      if (!moduleAnalytics.isRegistered) {
        this.$store.registerModule("analytics", moduleAnalytics);
        moduleAnalytics.isRegistered = true;
      }
      //debugger;
      vm.userName = this.$route.params.userName;
          if(localStorage.getItem("User_Journey_dayOrHour") != null || localStorage.getItem("User_Journey_dayOrHour") != undefined){
        this.filtrDay = localStorage.getItem("User_Journey_dayOrHour");
        this.changeFilterByDays(localStorage.getItem("User_Journey_dayOrHour"))
    }else{
       this.filtrDay = -1;
       this.changeFilterByDays(-1)
    }
      
    }
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>